<h1>{{ "ALREADY_HAVE_ACCOUNT" | translate }}</h1>
<form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="mb-0!">
  <input
    type="email"
    formControlName="email"
    [placeholder]="'EMAIL' | translate"
  />
  @if (loginForm.get('email')?.touched) { @if
  (loginForm.get('email')?.hasError('required')) {
  <div class="error">
    {{ "EMAIL_REQUIRED" | translate }}
  </div>
  } @if (loginForm.get('email')?.hasError('email')) {
  <div class="error">
    {{ "INVALID_EMAIL" | translate }}
  </div>
  } }
  <div class="password relative">
    <input
      [type]="showPassword ? 'text' : 'password'"
      formControlName="password"
      [placeholder]="'PASSWORD' | translate"
    />
    <button
      class="showPassword block absolute w-[24px] h-[24px] top-[12px] right-[12px]"
      type="button"
      [ngClass]="{active: showPassword}"
      (click)="showPassword = !showPassword"
      (keyup)="onKeyUp($event, 'showPassword')"
      tabindex="0"
    >
      {{ "SEE_PASSWORD" | translate }}
    </button>
  </div>
  @if (loginForm.get('password')?.touched) { @if
  (loginForm.get('password')?.hasError('required')) {
  <div class="error">
    {{ "PASSWORD_REQUIRED" | translate }}
  </div>
  } } @if (error) {
  <div class="error">
    @if (error.status === 403) { @if (activationEmailSent) {
    <p class="font-bold text-sm text-form-success">
      {{ "ACTIVATION_EMAIL_SENT" | translate }}
    </p>
    } @else {
    {{ error.error.error | translate }}.
    <button
      class="text-form-green cursor-pointer"
      (click)="sendActivationEmail()"
      (keyup)="onKeyUp($event, 'sendActivationEmail')"
      tabindex="0"
    >
      {{ "SEND_ANOTHER_ACTIVATION_LINK" | translate }}
    </button>
    } } @else {
    {{ error.error.error | translate }}
    }
  </div>
  }
  <button type="submit">{{ submitButtonText }}</button>
  <a routerLink="/forgotten-password">{{ "FORGET_PASSWORD" | translate }}</a>
</form>

<app-social-login-buttons></app-social-login-buttons>

<button
  routerLink="/signup"
  queryParamsHandling="preserve"
  class="block mt-3! btn btn-white full text-base! mobile:text-m!"
>
  {{ "SIGN_UP_WITH_EMAIL" | translate }}
</button>
